<fui-edit-fascia [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [valued]="valued"></fui-input-label>
        </fui-fixture>
        <fui-action-fixture *ngIf="showClear" class="actions">
            <fui-action class="actions-action" (click)="clear($event)">
                <fui-icon [height]="20" [width]="20" [icon]="'delete'"></fui-icon>
            </fui-action>
        </fui-action-fixture>
    </fui-fixtures>
    <fui-fixtures>
        <fui-fixture *ngIf="icon">
            <ng-content select="fui-icon"></ng-content>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)" [(ngModel)]="displayedValue"
                       [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text" inputmode="decimal">
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture *ngIf="notation">
            <fui-notation [title]="notation"></fui-notation>
        </fui-fixture>
        <fui-fixture *ngIf="validateable">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
